/**
 * Helpers for CMS rich text (portable text blocks or legacy plain strings).
 */

export function isPortableText(value) {
  return Array.isArray(value) && value.length > 0 && value[0]?._type === 'block';
}

export function blocksToPlainText(blocks) {
  if (!blocks) return '';
  if (typeof blocks === 'string') return blocks;
  if (!Array.isArray(blocks)) return '';

  return blocks
    .map((block) => {
      if (block?._type !== 'block') return '';
      return (block.children || []).map((child) => child.text || '').join('');
    })
    .filter(Boolean)
    .join(' ');
}
